"use client";
import * as React from "react";

export function UserIcon() {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html:
          "<svg id=\"I66:788;3:84\" layer-name=\"lucide/user-round\" width=\"18\" height=\"19\" viewBox=\"0 0 18 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"user-icon\" style=\"width: 18px; height: 18px\"> <path d=\"M9 10.25C11.0711 10.25 12.75 8.57107 12.75 6.5C12.75 4.42893 11.0711 2.75 9 2.75C6.92893 2.75 5.25 4.42893 5.25 6.5C5.25 8.57107 6.92893 10.25 9 10.25ZM9 10.25C10.5913 10.25 12.1174 10.8821 13.2426 12.0074C14.3679 13.1326 15 14.6587 15 16.25M9 10.25C7.4087 10.25 5.88258 10.8821 4.75736 12.0074C3.63214 13.1326 3 14.6587 3 16.25\" stroke=\"#2AAE3F\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path> </svg>",
      }}
    />
  );
}
